module.exports = require('./lib/clean');



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/index.js
// module id = 870
// module chunks = 16